import * as React from "react";

import "./mailing-lists-grid.scss";

import {cs}                 from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";
import {UseState}           from "@Common/react/use-state";
import {mailingListTypes}   from "@Common/ui-components/heavy/mailing-ui/create-mailing-list-modal/types/mailing-list-types";
import {
    getAddressListTypes,
    filterAddressListTypes
}                           from "@Common/ui-components/heavy/mailing-ui/mailing-icons/address-list-types";
import {BlockGuestAccess}   from "@Common/logic/block-guest-access";
import {CreateModal}        from "../mailing-lists-panel/create-new/create-modal/create-modal";

export const MailingListGrid = ({entityId, mailingLists}) => cs(
    consumeContext("company"),
    ["type", (_, next) => UseState({next})],
    ["modal", ({type}, next) => CreateModal({entityId, next})],
    ["isTypeAllowed", ({company}, next) => cs(
        consumeContext("session"),
        ({session}) => next((t) => (session.data?.branch ?? company?.prefs)?.addressListTypes?.includes(t)),
    )],
    ["blockGuestAccess", ({}, next) => BlockGuestAccess({next})],
    ["allowedAddressListTypes", ({company, isTypeAllowed, blockGuestAccess}, next) => next(
        getAddressListTypes(company?.prefs?.enableMapBasedMailingSupport)
            .filter(filterAddressListTypes(isTypeAllowed))
            .filter(t => !(blockGuestAccess && t.value === "CRM"))
    )],
    ({allowedAddressListTypes, type, modal}) => (
        <div className="mailing-list-grid-H2So4">
            <div className="header">
                <div className="title" xd-qa-type="label" xd-qa-name="Title">
                    Create or Upload a New List
                </div>
                <div className="sub-title" xd-qa-type="label" xd-qa-name="Subtitle">
                    Add a new address list by selecting from our robust audience targeting options or uploading your own list.
                </div>
            </div>
            <div className="mailing-list-grid-container">
            {
                allowedAddressListTypes.map(listType => (
                    <div
                        className="mailing-list-item"
                        key={listType.label}
                        onClick={(e) => {
                            e.stopPropagation()
                            type.onChange(listType.value);
                            modal.show({
                                service: mailingListTypes.find((type) => type.value === listType.value).service,
                                onCreated: () => mailingLists.reload()
                            })
                        }}
                    >
                        {!!listType.bannerMsg && (
                            <div className="banner" xd-qa-type="label" xd-qa-name={"Address Lists Banner " + listType.label}>
                                {listType.bannerMsg}
                            </div>
                        )}
                        <div className="icon" xd-qa-type="icon" xd-qa-name={"Address Lists " + listType.label}>
                            <img src={listType.icon} alt={listType.label}/>
                        </div>
                        <div className="text" xd-qa-type="label" xd-qa-name={"Address Lists " + listType.label}>
                            {listType.label}
                        </div>
                    </div>
                ))
            }
            </div>
        </div>
    )
);